import { SellTreezClient } from "../api/sell-treez-client";

/** Discount row from Sell Treez OpenSearch `discount` route. */
export type TreezSpecial = {
    discount_id?: string;
    discount_title?: string;
    title?: string;
    method?: string;
    active?: boolean;
    amount?: number;
    id?: string;
    [key: string]: unknown;
};

const DEFAULT_TIMEZONE = "America/New_York";

export class DiscountService {
    private readonly _client: SellTreezClient;

    private readonly _timezone: string;

    constructor(entityId: string, timezone: string = DEFAULT_TIMEZONE) {
        this._client = new SellTreezClient(entityId);
        this._timezone = timezone || DEFAULT_TIMEZONE;
    }

    //only get active discounts &excludeInactive=true
    getDiscounts = async (signal?: AbortSignal): Promise<TreezSpecial[]> => {
        const q = `discount?timezone=${encodeURIComponent(this._timezone)}`;
        return this._client.get<TreezSpecial[]>(q, signal);
    };
}

export { DEFAULT_TIMEZONE as DEFAULT_DISCOUNT_TIMEZONE };
